module.exports = __webpack_public_path__ + "img/prize0.9f40944.png";